import React, { useEffect, useState } from "react";
import Summary from "b2c6a1a8wq-ak/dist/components/Summary";
import axios from "axios";
import { getDoctorToken } from "../../utils";
import config from "../../config";

const ViewDtrfForm = (props) => {
  const [fetchDtrf, setFetchDtrf] = useState(null);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const getDtrf = () => {
    if (props.location.state) {
      const url = `${config.dtrf.viewDtrf}/${props.location.state}`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${getDoctorToken()}`,
          },
        })
        .then((res) => {
          console.log(res);
          let mandatory_Files = [];
          let nonMandatory_Files = [];
          if (res.data.data.data.test_info.non_mandatory_attachments) {
            nonMandatory_Files =
              res.data.data.data.test_info.non_mandatory_attachments;
          }
          if (res.data.data.data.test_info.mandatory_attachments) {
            mandatory_Files =
              res.data.data.data.test_info.mandatory_attachments;
          }
          setFilesToUpload([...mandatory_Files, ...nonMandatory_Files]);
          setFetchDtrf(res.data.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    if (!fetchDtrf) {
      setTimeout(() => {
        getDtrf();
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (fetchDtrf) {
    }
  }, [fetchDtrf]);
  return (
    <>
      {fetchDtrf && (
        <Summary
          from="Dashboard"
          fromDoctorDtrf={true}
          commercialInformation={fetchDtrf.commercialInformation}
          institute_info={{
            instituteName: { name: fetchDtrf.institute_name },
          }}
          doctor_info={fetchDtrf.doctor_info}
          test_info={fetchDtrf.test_info}
          tier={fetchDtrf.test_info.tier}
          trimester={fetchDtrf.test_info.trimester_test}
          collectionLocation={fetchDtrf.collectionLocation}
          patient_details={fetchDtrf.patient}
          medical_info={fetchDtrf.medical_info}
          sample_info={fetchDtrf.sample_info}
          payment={fetchDtrf.payment}
          files={fetchDtrf.medical_info.files}
          filesUploaded={filesToUpload}
          reports={{ reports: [...fetchDtrf.report] }}
          testStatus={fetchDtrf.status.status}
          bulkUploadFileOptions={fetchDtrf.medical_info.bulkUploadOptions}
          url={config.dtrf}
        />
      )}
    </>
  );
};

export default ViewDtrfForm;
